import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=52b70907"
import script from "./Templates.vue?vue&type=script&lang=js"
export * from "./Templates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports